import getCASMailbox2Operation from 'owa-service/lib/operation/getCASMailbox2Operation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function createRequestBody() {
    var options = {};
    var request = {
        Header: getJsonRequestHeader(),
        Options: options,
    };
    return request;
}
export default function getCASMailboxOptions() {
    return getCASMailbox2Operation(createRequestBody()).then(function (response) {
        return response.Options;
    });
}
//# sourceMappingURL=getCASMailboxOptions.js.map